import app from 'flarum/forum/app';
import CommunityFooter from './components/CommunityFooter';

app.initializers.add('tf-custom-footer', () => {
  // 将footer嵌入到body的最后
  let footerContainer = null;
  let footerMounted = false;

  const mountFooter = () => {
    // 检查是否已经存在footer容器
    if (!footerContainer) {
      footerContainer = document.getElementById('community-footer-container');
    }

    // 如果不存在，创建footer容器并添加到body最后
    if (!footerContainer) {
      footerContainer = document.createElement('div');
      footerContainer.id = 'community-footer-container';
      document.body.appendChild(footerContainer);
    }

    // 如果还没有挂载footer组件，则挂载
    if (!footerMounted && footerContainer) {
      // 使用Mithril渲染footer组件
      m.render(footerContainer, m(CommunityFooter));
      footerMounted = true;
    }
  };

  // 页面加载完成后挂载footer
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountFooter);
    } else {
      // DOM已经加载完成，立即挂载
      mountFooter();
    }

    // 监听路由变化，确保footer在页面切换后仍然存在
    const originalRouteSet = m.route.set;
    if (originalRouteSet) {
      m.route.set = function() {
        const result = originalRouteSet.apply(this, arguments);
        // 延迟一点时间确保DOM已更新，然后重新渲染footer
        setTimeout(() => {
          if (footerContainer) {
            m.render(footerContainer, m(CommunityFooter));
          }
        }, 100);
        return result;
      };
    }
  }
});

